var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"video_placeholder text-center"},[_c('p',{staticClass:"emoji"},[_vm._v(_vm._s(_vm.emoji))]),_c('p',{staticClass:"content mt-1"},[_vm._v(_vm._s(_vm.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }